import type React from "react";
import { useState } from "react";
import { Button } from "../ui/button";
import { PointIcon } from "./PointIcon";

interface TicketProps {
  code: string;
  pointsEarned: number;
  numberOfUses: number;
}

export const Ticket: React.FC<TicketProps> = ({ code, pointsEarned, numberOfUses }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(code);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  return (
    <div className="w-full relative bg-custom-ticket shrink-0">
      <div className="absolute -left-[8px] -top-[8px] bg-white w-5 h-5 rounded-b-full rounded-r-full rounded-l-full" />
      <div className="absolute -right-[8px] -top-[8px] bg-white w-5 h-5 rounded-b-full rounded-r-full rounded-l-full" />
      <div className="absolute -left-[8px] -bottom-[8px] bg-white w-5 h-5 rounded-t-full rounded-r-full rounded-l-full" />
      <div className="absolute -right-[8px] -bottom-[8px] bg-white w-5 h-5 rounded-t-full rounded-r-full rounded-l-full" />
      <div className="px-[26px] py-3 flex items-center justify-between">
        <div className="flex flex-col items-start">
          <div className="text-white text-s font-semibold">あなたの招待コード</div>
          <div className="text-white mb-1.5 text-2xl font-semibold">{code}</div>
          <div className="flex items-center w-full">
            <Button
              variant="outline"
              onClick={handleCopy}
              className={`w-[128px] border-white bg-transparent text-xs text-white hover:text-white font-normal rounded-full justify-center h-6 transition-all duration-200 ${
                isCopied ? "bg-primary hover:bg-primary" : "hover:bg-secondary/55"
              }`}
            >
              {isCopied ? "コピーしました" : "タップしてコビー"}
            </Button>
          </div>
        </div>

        <div className="relative w-full h-full">
          <div className="top-0 right-0">
            <div className="flex flex-col items-end">
              <div className="flex items-center gap-1">
                <p className="text-white text-xs font-semibold">あなたの招待人数</p>
              </div>
              <div className="text-white text-xs font-semibold mb-0.5">{numberOfUses}名</div>
              <div className="flex items-center gap-1">
                <PointIcon className="h-4 w-4" />
                <p className="text-white text-sm font-semibold">エントリーポイント</p>
              </div>
              <div className="text-white text-base font-semibold">{pointsEarned}pt</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
